import React from "react"
import { Typography } from "antd"
import { usePermission } from "src/hooks"
import { useAuthRequests } from "./model"
import { AuthRequestsFilters } from "./filters"
import { AuthRequestsSummary } from "./summary"
import { AuthRequestsTable } from "./requests-table"

export function AuthRequestsPage() {
  const { hasPermission } = usePermission()
  const {
    filters,
    items,
    pagination,
    summary,
    isLoading,
    isSummaryLoading,
    isExporting,
    applyFilters,
    refresh,
    handleTableChange,
    loadProcess,
    exportCsv,
  } = useAuthRequests()

  return (
    <>
      <AuthRequestsFilters
        filters={filters}
        onApply={applyFilters}
        onRefresh={refresh}
        onExport={exportCsv}
        canExport={hasPermission("auth-requests.export")}
        isLoading={isLoading}
        isExporting={isExporting}
      />

      <AuthRequestsSummary summary={summary} isLoading={isSummaryLoading} />

      <AuthRequestsTable
        items={items}
        pagination={pagination}
        filters={filters}
        isLoading={isLoading}
        onChange={handleTableChange}
        loadProcess={loadProcess}
      />

      <Typography.Paragraph type="secondary" style={{ marginTop: 8 }}>
        Запрос — каждый шаг «отправить код», включая повторные. Повторные запросы номера в течение 15 минут до успешного
        входа объединены в процесс входа: раскройте строку, чтобы увидеть весь каскад. «Seamless / SIM-Push» — МТС ещё
        не сообщил канал: он становится известен только при подтверждении входа. Даты — по Москве; сводка учитывает
        период и номер, но не способ и статус. Незавершённые запросы закрываются по тайм-ауту через 15 минут.
      </Typography.Paragraph>
    </>
  )
}
